import { render, staticRenderFns } from "./ModulePermssionControl.vue?vue&type=template&id=719ffa6e&scoped=true"
import script from "./ModulePermssionControl.vue?vue&type=script&lang=js"
export * from "./ModulePermssionControl.vue?vue&type=script&lang=js"
import style0 from "./ModulePermssionControl.vue?vue&type=style&index=0&id=719ffa6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719ffa6e",
  null
  
)

export default component.exports